import { RestClientApi } from '../restClient/restClientApi';

export interface NotificationServiceApi {
  sendEmail: (emailTo: string[], emailContents: string, subject: string) => Promise<boolean>;
  sendSlackNotification: (channelId: string, message: string) => Promise<boolean>;
}

export class NotificationServiceCommon implements NotificationServiceApi {
  constructor(
    private backendUrl: string,
    private token: string,
    private restClient: RestClientApi,
  ) {}

  getToken = async () => this.token;

  async sendEmail(sendTo: string[], body: string, subject: string): Promise<boolean> {
    const backstageToken = await this.getToken();
    const apiResponse = await this.restClient.post(
      `${this.backendUrl}/api/proxy/apigee-prod/notification-service?type=email`,
      { sendTo, body, subject },
      {
        headers: {
          authorization: `Bearer ${backstageToken}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (apiResponse.status === 200) {
      return true;
    }
    return false;
  }

  async sendSlackNotification(channelId: string, message: string): Promise<boolean> {
    const backstageToken = await this.getToken();
    const apiResponse = await this.restClient.post(
      `${this.backendUrl}/api/proxy/apigee-prod/notification-service?type=slack`,
      { channelId, message },
      {
        headers: {
          authorization: `Bearer ${backstageToken}`,
          'Content-Type': 'application/json',
        },
      },
    );

    if (apiResponse.status === 200) {
      return true;
    }
    return false;
  }
}
